import { render, staticRenderFns } from "./RiskPlanList.vue?vue&type=template&id=64a36ef3&"
import script from "./RiskPlanList.vue?vue&type=script&lang=js&"
export * from "./RiskPlanList.vue?vue&type=script&lang=js&"
import style0 from "./RiskPlanList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports